import { useState, useEffect } from 'react';
import { GetTermsAndConditionApi } from '../api/request/common.js';

const useTermsAndConditions = () => {
  const [tnc, setTnc] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const getTermsAndCondition = async () => {
      setIsLoading(true);
      setError(null);
      try {
        const { data } = await GetTermsAndConditionApi();
        if (data?.success) {
          setTnc(data?.data?.[0] || {});
        }
      } catch (error) {
        setError(error);
      } finally {
        setIsLoading(false);
      }
    };

    getTermsAndCondition();
  }, []);

  return { tnc, isLoading, error };
};

export default useTermsAndConditions;
